var $35da740d59af89ba$exports = {};
const $35da740d59af89ba$var$menuToggle = document.querySelector('.menu-toggle');
const $35da740d59af89ba$var$nav = document.getElementById('main-nav');
const $35da740d59af89ba$var$navClose = document.querySelector('.mobile-nav-close');
function $35da740d59af89ba$var$openMenu() {
    $35da740d59af89ba$var$nav.classList.add('is-open');
    $35da740d59af89ba$var$menuToggle.classList.add('is-active');
    $35da740d59af89ba$var$menuToggle.setAttribute('aria-expanded', 'true');
    $35da740d59af89ba$var$nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
}
function $35da740d59af89ba$var$closeMenu() {
    $35da740d59af89ba$var$nav.classList.remove('is-open');
    $35da740d59af89ba$var$menuToggle.classList.remove('is-active');
    $35da740d59af89ba$var$menuToggle.setAttribute('aria-expanded', 'false');
    $35da740d59af89ba$var$nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
}
$35da740d59af89ba$var$menuToggle.addEventListener('click', ()=>{
    $35da740d59af89ba$var$nav.classList.contains('is-open') ? $35da740d59af89ba$var$closeMenu() : $35da740d59af89ba$var$openMenu();
});
$35da740d59af89ba$var$navClose.addEventListener('click', $35da740d59af89ba$var$closeMenu);
$35da740d59af89ba$var$nav.querySelectorAll('a').forEach((link)=>{
    link.addEventListener('click', $35da740d59af89ba$var$closeMenu);
});
document.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape' && $35da740d59af89ba$var$nav.classList.contains('is-open')) $35da740d59af89ba$var$closeMenu();
});


//# sourceMappingURL=parcel-app.051217e5.js.map
